<template>
  <div>
    <div>
      <colored-checkbox
        data-track="Channel Filters - Hellopeter"
        :is-checked="isHpChecked"
        :is-disabled="isHpDisabled"
        class="margin-right-15 margin-bottom-10"
        @cb-toggle="toggleCbState($event, 'HELLOPETER')">
        <span class="checkbox-label"><img src="/static/img/reviews/hp_channel.svg"/> &nbsp;Hellopeter</span>
      </colored-checkbox>
    </div>

    <div v-if="isGoogleConnected">
      <div class="is-clearfix showOnHover">
        <colored-checkbox
          data-track="Channel Filters - Google"
          :is-checked="isGoogleChecked"
          class="is-pulled-left margin-right-15 margin-bottom-10"
          @cb-toggle="toggleCbState($event, 'GOOGLE')">
          <span class="checkbox-label"><img class="google_channel_hg" src="/static/img/reviews/google_channel_hq.png"/> &nbsp;Google</span>
        </colored-checkbox>
        <span class=" is-pulled-left margin-right-25 is-hidden margin-top-5" v-if="edit">
          <a class="blue-link margin-right-10" href="#" @click.prevent="openChannelModal"
             data-track="Channel Filter - Google edit link">Edit</a>
          <a class="blue-link" href="#" @click.prevent="openChannelModal"
             data-track="Channel Filter - Google delete link">Delete</a>
        </span>
      </div>
    </div>

    <div v-if="isFacebookReviewsConnected">
      <div class="is-clearfix showOnHover">
        <colored-checkbox
          data-track="Channel Filters - Facebook"
          :is-checked="isFacebookChecked"
          class="is-pulled-left margin-right-15 margin-bottom-10"
          @cb-toggle="toggleCbState($event, 'FACEBOOK')">
          <span class="checkbox-label"><img class="google_channel_hg" src="/static/img/reviews/fb.png"/> &nbsp;Facebook</span>
        </colored-checkbox>
        <span class=" is-pulled-left margin-right-25 is-hidden margin-top-5">
              <a class="blue-link margin-right-10" href="#" @click.prevent="openChannelModal"
                 data-track="Channel Filter - Facebook edit link">Edit</a>
              <a class="blue-link" href="#" @click.prevent="openChannelModal"
                 data-track="Channel Filter - Facebook delete link">Delete</a>
            </span>
      </div>
    </div>

    <div v-if="hasAvailableChannels" class="text-blue pad-left-7">
      + &nbsp;
      <a class="blue-link text-underline-no" href="#" data-track="Channel Filter - Add link"
         @click.prevent="openChannelModal">Add channel</a>
    </div>

    <div v-if="channelModal.show" id="channelModal" class="modal is-active modal-new font-size-12">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <a class="modal-close-link" href="#" @click.prevent="closeChannelModal">
            <img src="/static/img/ads/modal_close.svg" class="valign-bottom"/>
          </a>
          <div class="modal-card-head-title">Connect your channel</div>
        </header>

        <section class="modal-card-body">
          <connect-channel-card class="margin-right-17" :connectBtnAction="openGmb" v-if="!isGoogleConnected"/>
          <connect-channel-card class="margin-right-17" :editBtnAction="function(){openGmb('locationUpdate')}"
                                :removeBtnAction="removeGmb"
                                :accountDetails="{'accountName': gmbSetup.data.accountName, 'bizName': gmbSetup.data.locationData.locationName, 'location': gmbSetup.data.locationData.address.administrativeArea ? gmbSetup.data.locationData.address.administrativeArea : gmbSetup.data.locationData.address.locality}"
                                v-if="isGoogleConnected"/>
          <connect-channel-card channel="fb" :isNew="true" :connectBtnAction="openFB" v-if="!isFacebookReviewsConnected"/>
          <connect-channel-card channel="fb" :accountDetails="{'pageID': fbReviewsSetup.data.pageID}" :isNew="true" :removeBtnAction="removeFBReviews"
                                v-if="isFacebookReviewsConnected"/>
        </section>
      </div>
    </div>

    <GMBModal
      v-if=channelModal.google.show
      :show=channelModal.google.show
      :page=channelModal.google.page
      :redirectUrlParam="[gmbRedirect]"
      @closeModal="channelModal.google.show=false"
      @updateFinished="googleConnected"
    />
    <ModalPopup
      title="Confirm removing account ?"
      body="You are about to remove your Google My Business account. This step cant be undone and will require you to go through the steps to add your account again."
      primaryBtnText="Cancel"
      secondaryBtnText="Remove"
      :secondaryBtnAction="removeGMBSetup"
      v-if="removeGmbModal.show"
    >
    </ModalPopup>
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef */
import {gmb, misc} from '@/mixins'
import axios from 'axios'
import ColoredCheckbox from './ColoredCheckbox'
import ConnectChannelCard from './ConnectChannelCard'
import GMBModal from './GMBModal'
import ModalPopup from './../components/ModalPopup.vue'

export default {
  name: 'ChannelManage',
  props: {
    hpEnable: {
      type: Boolean,
      default: true
    },
    hpChecked: {
      type: Boolean,
      default: false
    },
    googleChecked: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: true
    },
    gmbRedirect: {
      type: String,
      default: 'reviews-list'
    },
    facebookChecked: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ColoredCheckbox,
    ConnectChannelCard,
    GMBModal,
    ModalPopup
  },
  mixins: [misc, gmb],
  data () {
    return {
      isHpChecked: this.hpChecked,
      isHpDisabled: false,

      isGoogleChecked: this.googleChecked,
      isFacebookChecked: false,
      facebookReviewsLoginURL: '',

      channelModal: {
        show: false,
        google: {
          show: false,
          page: ''
        }
      }
    }
  },
  created () {
    this.checkGMBSetup()
    this.checkHpStatus()
    this.getFacebookReviewsLoginURL()
    this.checkFacebookReviewsSetup()
  },
  computed: {
    hasAvailableChannels () {
      return !(this.isFacebookReviewsConnected && this.isGoogleConnected)
    }
  },
  methods: {
    checkHpStatus () {
      if (!this.hpEnable) {
        this.isHpChecked = true
        this.isHpDisabled = true
      }

      if (this.facebookChecked) {
        this.isFacebookChecked = true
      }
    },
    toggleCbState (isChecked, channel) {
      if (channel === 'HELLOPETER') {
        this.isHpChecked = isChecked
      } else if (channel === 'GOOGLE') {
        this.isGoogleChecked = isChecked
      } else if (channel === 'FACEBOOK') {
        this.isFacebookChecked = isChecked
      }
      this.$emit('channel-manage-toggle', {
        channel,
        checked: isChecked
      })
    },
    openChannelModal () {
      this.channelModal.show = true
    },
    closeChannelModal () {
      this.channelModal.show = false
    },
    openGmb (page = '') {
      this.channelModal.google.page = page
      this.channelModal.google.show = true
    },
    googleConnected () {
      this.displaySuccessMsg(`Your location has been successfully updated!`, 'Updated the Google My Business location.')
      this.checkGMBSetup()
        .then(() => {
          this.closeChannelModal()
        })
    },
    removeGmb () {
      this.closeChannelModal()
      this.removeAccountConfirmation()
    },
    openFB () {
      const businessSlug = localStorage.getItem('org_slug')
      axios.get(`/social/fb/${businessSlug}/get-auth-url-for-reviews`)
        .then(({data}) => {
          this.facebookReviewsLoginURL = data.original_login_url
          window.location = this.facebookReviewsLoginURL
        })
        .catch((error) => {
          this.displayErrMsg(error, 'Failed loading facebook login details', 'Oops, something went wrong. Please try reloading or contact our administrator')
        })
    },
    removeFBReviews () {
      this.removeFacebookReviewsSetup()
    },
    getFacebookReviewsLoginURL () {
      const businessSlug = localStorage.getItem('org_slug')
      axios.get(`/social/fb/${businessSlug}/get-auth-url-for-reviews`)
        .then(({data}) => {
          this.facebookReviewsLoginURL = data.original_login_url
        })
        .catch((error) => {
          this.displayErrMsg(error, 'Failed loading facebook login details', 'Oops, something went wrong. Please try reloading or contact our administrator')
        })
    }
  },
  watch: {
    hpChecked (n) {
      this.isHpChecked = n
    },
    googleChecked (n) {
      this.isGoogleChecked = n
    }
  }
}
</script>

<!-- Local Scoped CSS Begins -->
<style scoped>
.checkbox {
  margin-left: 3px !important;
  margin-bottom: 9px !important;
}

.checkbox-label {
  margin-left: 9px;
  font-size: 12px;
  font-weight: normal;
}

.blue-link {
  margin: 0 0 8px 4px;
  display: inline-block;
}

#channelModal .modal-card {
  max-width: 642px;
  height: 383px;
}

#channelModal .modal-card-head-title {
  margin-bottom: 2px;
  font-size: 14px;
}

#channelModal .modal-card-body {
  padding-left: 30px;
}

.margin-top-5 {
  margin-top: -3px !important;
}

img.google_channel_hg {
  width: 15px !important;
}
</style>
<!-- Local Scoped CSS Ends -->



// WEBPACK FOOTER //
// src/components/ChannelManage.vue